module.exports = __webpack_public_path__ + "img/myloc.5617ea2a.png";